<template>
  <div>
    <slot name="ativador" :callbackAtivarDialog="() => dialog_ativo = ! dialog_ativo"></slot>

    <SysDialogFullscreen v-model="dialog_ativo">
      <template #titulo.text>
        <div class="d-flex align-center">
          <span>Detalhamento</span>

          <v-divider vertical dark class="mx-2" />

          <span v-if="linha" class="font-12 text-truncate">
            <template v-if="linha.status_movimentacao">
              {{ linha.status_movimentacao }}
              <v-icon dark small>mdi-chevron-right</v-icon>
            </template>

            <template v-if="linha.descricao_segmento">
              {{ linha.descricao_segmento }}
              <v-icon dark small>mdi-chevron-right</v-icon>
            </template>

            <template v-if="linha.descricao_fornecedor">
              {{ linha.descricao_fornecedor }}
              <v-icon dark small>mdi-chevron-right</v-icon>
            </template>

            {{ linha.descricao_linha }}
          </span>
        </div>
      </template>

      <Tabela
        v-if="dialog_ativo"
        class="pl-2 pr-1"
        :linha="linha"
        :filtros="filtros"
        :periodo_analise="periodo_analise"
      />
    </SysDialogFullscreen>
  </div>
</template>

<script>
import SysDialogFullscreen from "@/components/padraoDeLayout/SysDialogFullScreen";
import Tabela from "@/components/Diagnostico/SlowNoMoving/MovimentacaoEstoque/DetalhamentoDuploClique/Tabela.vue";

export default {
  name: "DetalhamentoDuploClique",
  components: {
    SysDialogFullscreen,
    Tabela
  },
  props: {
    linha: Object,
    filtros: Object,
    periodo_analise: Object,
    ativar_dialog_em_mudanca_linha: Boolean
  },
  data: () => ({
    dialog_ativo: false,
  }),
  watch: {
    linha() {
      if (this.linha && this.ativar_dialog_em_mudanca_linha) {
        this.dialog_ativo = true;
      }
    },
    dialog_ativo() {
      if (!this.dialog_ativo) {
        this.$emit("dialog-fechado", {});
      }
    }
  }
}
</script>

<style scoped>

</style>
